import React from 'react'

export default function Redhead(props) {
    return (
        <div className="d-inline-flex rounded text-white bg-danger bg-gradient px-3 pt-1 my-2 ml-auto">
                <h1><b>{props.pheading}</b></h1>
        </div>
    )
}
